import React, { useCallback } from "react";
import { Button, Confirm } from "react-admin";
import useOpenState from "shared/hooks/useOpenState";

interface ConfirmActionButtonProps {
  label: string;
  color?: "primary" | "error";
  variant?: "contained" | "text";
  startIcon: React.ReactElement;
  action: (args?: unknown) => void | Promise<void>;
  confirmTitle: string;
  confirmContent: string;
  isPending?: boolean;
  triggerBeforeOpen?: () => Promise<boolean> | boolean;
}

const ConfirmActionButton: React.FC<ConfirmActionButtonProps> = ({
  label,
  color = "primary",
  variant = "contained",
  startIcon,
  action,
  confirmTitle,
  confirmContent,
  isPending,
  triggerBeforeOpen,
}) => {
  const { open, handleOpen, handleClose } = useOpenState();

  const handleClick = useCallback(async () => {
    if (triggerBeforeOpen) {
      const result = await triggerBeforeOpen();
      if (!result) return;
    }
    handleOpen();
  }, [triggerBeforeOpen, handleOpen]);

  const handleConfirm = useCallback(() => {
    action();
    handleClose();
  }, [action, handleClose]);

  return (
    <>
      <Button label={label} onClick={handleClick} color={color} variant={variant} startIcon={startIcon} />
      <Confirm
        isOpen={open}
        loading={isPending}
        title={confirmTitle}
        content={confirmContent}
        onConfirm={handleConfirm}
        onClose={handleClose}
      />
    </>
  );
};

export default ConfirmActionButton;
